<template>
  <div>
    <el-row>
      <el-col :span="17">
        <!-- 面包屑导航区域-->
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
          <el-breadcrumb-item>Factory Id:{{factory.id}} Supplier:{{factory.supplier}} Location:{{factory.location}} </el-breadcrumb-item>
          <el-breadcrumb-item>Machine</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-card>
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item>
          <el-button type="primary" @click="customerDialogOpen('add')">Add</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="machineList"
                :default-sort="{ prop: 'machineNumber', order: 'ascending' }"
                border stripe style="width: 100%">
        <!--          <el-table-column type="index" label="#"></el-table-column>-->
        <el-table-column
          prop="factoryId"
          label="Factory Id"         sortable
          width="150">
        </el-table-column>
        <el-table-column
          prop="id"
          label="Machine Id"         sortable
          width="150">
        </el-table-column>
        <el-table-column
          prop="machineNumber"
          label="Machine Number" sortable
          width="150">
        </el-table-column>
<!--        <el-table-column-->
<!--          prop="status"-->
<!--          label="Status" sortable-->
<!--          :formatter="formatStatus"-->
<!--          width="150">-->
<!--        </el-table-column>-->
        <el-table-column
          prop="machinePictureUrl"
          label="Machine Picture" sortable
          width="150">
          <template slot-scope="scope">
            <img :src="scope.row.machinePictureUrl" min-width="30" height="30"  @click="showpreviewPic(scope.row.machinePictureUrl)">
          </template>
        </el-table-column>
        <el-table-column label="Operation" width="">
          <template slot-scope="index">
            <!-- <el-button type="info" plain size="mini" @click="view(props.row.id)">View</el-button> -->
<!--            <el-button type="info" plain size="mini" @click="getOutputCalendar(index)">Output Calendar</el-button>-->
            <el-button type="info" plain size="mini" @click="setUp(index)">Set Up</el-button>
            <!--              <el-button type="info" plain size="mini" @click="getPermissions(index)">Followers</el-button>-->
            <el-button type="info" plain size="mini" @click="customerDialogOpen(index)">Edit</el-button>
            <!--          <el-button type="info" plain size="mini" @click="del(props.row.code)">Delete</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog title="Machine"
               width="50%" :visible.sync="dialogFormVisible" >
              <el-form :model="form" label-width="200px">
                <el-form-item label="Machine Id:">
                  <el-input disabled v-model="form.id" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item required label="Machine Number:">
                  <el-input v-model="form.machineNumber" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item required label="Machine Picture:">
                  <el-upload
                    class="avatar-uploader"
                    ref="upload"
                    :limit="1"
                    :action="uploadImgUrl"
                    :before-upload="beforeAvatarUpload"
                    :on-success="handleAvatarSuccess"
                    :show-file-list ="false"
                    :multiple="false"
                    accept=".jpg, .png"
                  >
                    <!--              <i class="el-icon-plus avatar-uploader-icon"></i>-->
                    <img v-if="form.machinePictureUrl" :src="form.machinePictureUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div class="el-upload__tip" slot="tip">Must be JPG/PNG and less than 2MB</div>
                  </el-upload>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">Cancel</el-button>
                <el-button type="primary" @click="customerDialogSave()">Save</el-button>
              </div>
    </el-dialog>
    <el-dialog :visible.sync="lookdialogVisible" :modal="false" title="" width="30%">
      <img :src="previewpic" alt=""  width="100%" />
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Machine',
  data () {
    return {
      lookdialogVisible: false,
      previewpic: '',
      uploadImgUrl: axios.defaults.baseURL + '/file/upload/img/',
      form: {
        factoryId: '',
        id: '',
        machineNumber: '',
        machinePictureUrl: ''
      },
      resetForm: {
        factoryId: '',
        id: '',
        machineNumber: '',
        machinePictureUrl: ''
      },
      dialogFormVisible: false,
      factory: {},
      machineList: []
    }
  },
  created () {
    this.getMachineList()
    this.factory = this.$route.query
  },
  methods: {
    showpreviewPic (url) {
      this.previewpic = url
      this.lookdialogVisible = true
    },
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!(file.type === 'image/jpeg' || file.type === 'image/png')) {
        this.$message.error('The format must be JPG/PNG!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('Must be less than 2MB!')
        return false
      }
    },
    handleAvatarSuccess (res, file) {
      this.$refs.upload.clearFiles()
      // this.form.picUrl = URL.createObjectURL(file.raw)
      this.form.machinePictureUrl = res
    },
    async customerDialogSave () {
      if (!(this.form.machineNumber)) {
        this.$notify({
          title: 'Please enter machineNumber',
          type: 'warning'
        })
        return
      }
      if (!(this.form.machinePictureUrl)) {
        this.$notify({
          title: 'Please upload pictures',
          type: 'warning'
        })
        return
      }
      await this.$http.post('/machine/saveOrUpdateMachine', this.form)
        .then((res) => {
          if (res.data === 200) {
            this.$notify({
              title: 'Success',
              type: 'success'
            })
          }
          this.dialogFormVisible = false
          this.getMachineList()
        })
    },
    customerDialogOpen (x) {
      this.dialogFormVisible = true
      if (x === 'add') {
        this.form.factoryId = this.factory.id
        this.form.id = ''
        this.form.machineNumber = ''
        this.form.machinePictureUrl = ''
      } else {
        // this.form = x.row
        this.form.factoryId = x.row.factoryId
        this.form.id = x.row.id
        this.form.machineNumber = x.row.machineNumber
        this.form.machinePictureUrl = x.row.machinePictureUrl
      }
    },
    setUp (index) {
      this.$router.push(`/outputCalendar?machineNumber=${index.row.machineNumber}&machineId=${index.row.id}&id=${this.factory.id}&supplier=${this.factory.supplier}&location=${this.factory.location}`)
    },
    // getOutputCalendar (index) {
    //   this.$router.push(`/followup?machineNumber=${index.row.machineNumber}&machineId=${index.row.id}&id=${this.factory.id}&supplier=${this.factory.supplier}&location=${this.factory.location}`)
    // },
    formatStatus (row, column, cellValue, index) {
      return row.status === '1' ? 'runnig' : row.status === '0' ? 'stop' : 'unknown'
    },
    async getMachineList () {
      const { data: res } = await this.$http.get('/machine/getMachineList', { params: this.$route.query })
      for (let i = 0; i < res.length; i++) {
        res[i].machineNumber = Number(res[i].machineNumber)
        res[i].factoryId = Number(res[i].factoryId)
      }
      // console.log(11122233)
      // console.log(res)
      // this.machineList = res.map(item => ({
      //   ...item,
      //   mixedData: Number(item.mixedData.replace(/[^\d.-]/g, '')) || 0
      // }))
      this.machineList = res
      this.total = res.total
    }
  }
}
</script>

<style scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
